export type Filters = {
  spaceIds: string[];
  mediaOwnerNames: string[];
  environments: string[];
  formatSizeNames: string[];
  statuses: string[];
};

export type Filter = {
  key: string;
  label: string;
};

export enum FilterType {
  DRAFTS = 'DRAFTS',
  FRAMES = 'FRAMES',
  LINKED_ASSETS = 'LINKED_ASSETS',
  LIVE_ENTITIES = 'LIVE_ENTITIES',
}
